export class ConfiguracionVentanilla {
    public idConfiguracionVentanilla: number;
    public idTramite: string;
    public estado: string;
    public tipoIdFuncionario: string;
    public numeroIdFuncionario: string;
    public numeroVentanilla: string;
    public sede: string;
    public estadoVentanilla: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
}